import { IHttpClient } from "../../../lib/http";
import { ReplicatePropertyRequestDto } from "../domain/replicateProperty.entity";

export async function executeReplicate(
  httpClient: IHttpClient,
  originPropertyTicker: string,
  targetPropertyTicker: string,
  options: {
    migrateAri: boolean;
  },
  emails?: string[]
): Promise<void> {
  await httpClient.post<ReplicatePropertyRequestDto, void>(
    "/replicate",
    {
      toDevel: true,
      originPropertyTicker,
      targetPropertyTicker,
      options,
      emails,
    },
    {
      params: {
        executionName: `replicate-${originPropertyTicker}-${targetPropertyTicker}-${new Date().getTime()}`,
      },
    }
  );
}
